<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de produção ambulatorial - BPA">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/ambulatorio/relatorio-producao-ambulatorial/List'

export default {
    components: { List },
}
</script>